import { render, staticRenderFns } from "./BenefitsHorizontalList.vue?vue&type=template&id=f240f438"
import script from "./BenefitsHorizontalList.vue?vue&type=script&lang=js"
export * from "./BenefitsHorizontalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports